import Immutable from 'immutable';

// constants
import {
  UPDATE_PAYMENT_DETAILS,
  PAYMENT_DETAILS_FETCH,
  CARD_REPLACE,
  RENEW_SUBSCRIPTION, CANCEL_SUBSCRIPTION
} from '../constants/paymentDetailsTypes';

// lib
import httpReducer from '../lib/httpReducer';

const show = function(map, action) {
  const normalized  = action.payload.normalized || {};
  const entities    = normalized.entities || {};
  const entity      = entities.paymentDetails || {};
  const paymentDetails = entity[normalized.result];

  if (paymentDetails) {
    map.set('data', Immutable.fromJS(paymentDetails));
  }
};

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case PAYMENT_DETAILS_FETCH: return httpReducer(state, action, show);
    case UPDATE_PAYMENT_DETAILS: return httpReducer(state, action, show);
    case CARD_REPLACE: return httpReducer(state, action, show);
    case RENEW_SUBSCRIPTION: return httpReducer(state, action, show);
    case CANCEL_SUBSCRIPTION: return httpReducer(state, action, show);
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/paymentDetails.js